
// @ts-check

import React from "react";
import NamedBuildingInfoScreen from "./NamedBuildingInfoScreen";
import NamedBuildingList from "./NamedBuildingList";


/**
 * @param {{}} props 
 * @returns {JSX.Element}
 */
function NamedBuildingOnePageLayout(props) {

    const namedBuildingCards = [];

    const sharedStyle = {
        width: '95%',
        height: 500,
        marginBottom: 40,
    };

    const largeScreenSharedStyle = {
        width: '75%',
        height: 500,
        marginBottom: 40,
        marginLeft: 'auto',
        marginRight: 'auto'
    };

    var leftStyle = { };
    var rightStyle = { };

    if (window.screen.width <= 2000) {
        leftStyle = {...sharedStyle, marginLeft: 0, marginRight: '5%' };
        rightStyle = {...sharedStyle, marginLeft: '5%', marginRight: 0 };
    } else {
        leftStyle = {...largeScreenSharedStyle };
        rightStyle = {...largeScreenSharedStyle };
    }

    for (let i = 0, isEven = true; 
         i < NamedBuildingList.length; 
         i++, isEven = !isEven) 
    {
        namedBuildingCards[i] = (
            <div style={ isEven ? rightStyle : leftStyle }>
                <NamedBuildingInfoScreen 
                    title={NamedBuildingList[i].title} 
                    info={NamedBuildingList[i].info} 
                    image={NamedBuildingList[i].image} 
                    mirrored={!isEven}
                    narrow={true} />;
            </div>); 
    }

    return (
        <div style={{ marginTop: 200 }}>
            <>{namedBuildingCards}</>
        </div>
    );
}


export default NamedBuildingOnePageLayout;
